import Extend from 'flarum/common/extenders';
import User from 'flarum/common/models/User';
import Model from 'flarum/common/Model';
import commonExtend from '../common/extend';
import UserSuspendedNotification from './components/UserSuspendedNotification';
import UserUnsuspendedNotification from './components/UserUnsuspendedNotification';
export default [...commonExtend, new Extend.Notification() //
.add('userSuspended', UserSuspendedNotification).add('userUnsuspended', UserUnsuspendedNotification), new Extend.Model(User).attribute('suspendedUntil', Model.transformDate).attribute('suspendReason').attribute('suspendMessage')];